<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="t3">This one is for my readers.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?3358b8b3